module.exports = __webpack_public_path__ + "img/appAsset-brand--fc.ecc4f3c9.svg";